import React, { useEffect, useState } from 'react';
import NouveauPerso from './NouveauPerso';
import LogoutButton from '../Logout';
import { ReactComponent as Plus } from '../svg/plus.svg';
const SelectPerso = ({ personnages, setSelectedPerso, joueur,token, fetchPerso }) => {
    const [newClick, setNewClick] = useState(false);
    const handleSelect = (personnage) => {
        setSelectedPerso(personnage)

    };
    const handleNew = () => {
        setNewClick(true)
    };
    useEffect(() => {
        fetchPerso();
    }, []);
    if (newClick) {
        return (
            <NouveauPerso
                idJoueur={joueur}
                setNewClick={setNewClick}
                setSelectedPerso={setSelectedPerso}
                token={token}
            />
        )
    }


    return (
        <React.Fragment>
        <div className='grid_select_perso'>
            {
                personnages.map((personnage, index) => {
                    if (personnage.idPersonnage !== null) {
                        return (
                            <div key={index} className='flex flex_column flex_center margin_1em img-select' onClick={() => { handleSelect(personnage) }}>
                                <img className='profil_pic' src={personnage.profilPath} alt="Profile" />
                                <div className={"select-pseudo"}>{personnage.prenom}</div>
                            </div>
                        );
                    } else {
                        return null; 
                    }
                })
            }
            <div className='flex flex_column flex_center margin_1em img-select' onClick={() => { handleNew() }}>
                <Plus className='height_10em profil_pic' ></Plus>
                <div className={"select-pseudo"}>Nouveau</div>
            </div>
        </div>
        <LogoutButton/>
        </React.Fragment>
    );
};

export default SelectPerso;
